import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Auth.css';
import { BastionLockup } from './Brand';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post('/auth/forgot-password', { email });
      // Backend always returns 200 regardless of whether the email exists,
      // to prevent enumeration. We show the same confirmation either way.
      setSubmitted(true);
    } catch (err) {
      // Only reachable on actual validation errors (e.g. malformed email).
      setError(err.response?.data?.errors?.[0]?.msg
            || err.response?.data?.error
            || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-background">
        <div className="auth-gradient"></div>
      </div>

      <div className="auth-card">
        <div className="auth-header">
          <BastionLockup className="auth-lockup" variant="outline" markSize={64} />
          <h2>Reset password</h2>
          <p>{submitted
            ? "Check your inbox for the reset link."
            : "Enter the email you sign in with. We'll send a reset link."}
          </p>
        </div>

        {error && <div className="error-message">{error}</div>}

        {submitted ? (
          <div style={{
            background: 'rgba(34, 197, 94, 0.08)',
            border: '1px solid rgba(34, 197, 94, 0.25)',
            color: '#166534',
            padding: '14px 16px',
            borderRadius: 8,
            fontSize: 14,
            lineHeight: 1.55,
            marginBottom: 20,
          }}>
            If an account exists for <strong>{email}</strong>, a password
            reset link has been sent. The link expires in 60 minutes.
            <br /><br />
            Didn't receive it? Check your spam folder, or ask your
            administrator — if SMTP isn't configured, the link is logged
            to the backend console.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="input-group">
              <label>Email address</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                autoComplete="email"
                autoFocus
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        )}

        <div className="auth-footer">
          <p><Link to="/login">← Back to sign in</Link></p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
